import React, { useEffect } from 'react';
import Axios from 'axios';

const ErrorPage = ( {error, resetErrorBoundary} )=>{
    

    useEffect(() => {
        console.log( error.message );
        console.log( error.stack)
        Axios({
            method: 'POST',
            url: `${process.env.REACT_APP_API_HOST}/api/error/store`,
            data:JSON.stringify({message:error.message, stack:error.stack}),
            headers: {
                'Content-Type': 'application/json',
                'Authorization':'Bearer'+sessionStorage.getItem('user')
            }
        });
    }, [error]);
    
    return (
        <div className="text-center">
            <div className="no_data">오류가 발생했습니다.</div>
            <br />
            <a className="btn _blue" href="/">홈</a>
        </div>
    )
};
export default ErrorPage;